import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import MainHeader from '@Layouts/MainHeader'

import { useMeQuery } from '../../../store/api'
import type { Topbar, TrackingSummary } from '../../../store/types/dashboard'
import ReportLink from '../../menu/items/report-link'

type DashboardHeaderProps = {
  topbar: Topbar | undefined
  trackingSummary: TrackingSummary | undefined
}

function DashboardHeader({ topbar, trackingSummary }: DashboardHeaderProps) {
  const { data } = useMeQuery()
  const navigate = useNavigate()

  const [lastUpdated, setLastUpdated] = useState('')

  useEffect(() => {
    if (topbar?.last_updated) {
      setLastUpdated(topbar?.last_updated.toFormat('LLLL dd, yyyy'))
    }
  }, [topbar])

  return (
    <MainHeader
      title={data?.name}
      subtitle={
        <>
          <ul className="flex flex-row gap-2 items-center py-1">
            <li className="pr-2 text-medium text-sm text-gray-900">
              Tracking summary
            </li>
            <button onClick={() => navigate('/products')}>
              <li className="text-medium text-sm	text-gray-900 text-center">
                <span className="px-2 py-1  bg-gray-100 rounded-2xl">
                  {trackingSummary?.products} products
                </span>
              </li>
            </button>
            <ReportLink to={'/reports/brand'} reportType="Brand Report">
              <button>
                <li className="text-medium text-sm text-gray-900 text-center">
                  <span className="px-2 py-1 bg-gray-100 rounded-2xl">
                    {trackingSummary?.brands} brands
                  </span>
                </li>
              </button>
            </ReportLink>
            <ReportLink to={'/reports/category'} reportType="Brand Report">
              <button>
                <li className="text-medium text-sm	text-gray-900 text-center ">
                  <span className="px-2 py-1  bg-gray-100 rounded-2xl">
                    {trackingSummary?.categories} categories
                  </span>
                </li>
              </button>
            </ReportLink>
          </ul>
        </>
      }
      rightTitle={`Last Updated at ${lastUpdated}.`}
    />
  )
}

export default DashboardHeader
